import waitFor from '../../utils/WaitFor'

function init () {
    // GTM may load subsequent scripts asyncronously, this means that rudderanalytics may not be loaded yet. We need to wait
    // for it to be ready before using its ready API
    waitFor(
        () => window.rudderanalytics,
        500,
        100,  
        () => window.rudderanalytics.ready(tryUpdateRudderstackAnonymousIds),
        () => console.error("Failed to initialise rudderanalytics")
    );
}

function tryUpdateRudderstackAnonymousIds () {
    let anonId;
    // I have noticed times when getAnonymousId returned an empty string. Therefore, we should retry until
    // we get a proper ID
    waitFor(
        () => anonId = window.rudderanalytics.getAnonymousId(),
        20,
        100,
        () => setRudderstackAnonymousIdElementValues(anonId),
        () => console.error("Failed to get rudderstack anonymous id")
    );
}

function setRudderstackAnonymousIdElementValues (id) {
    var elems = [...document.querySelectorAll(".ps-rudderstack-anonymous-id")]

    for (const elem of elems) {
        elem.value = id;
    }
}

const RudderstackUtils = { init }

export default RudderstackUtils



// WEBPACK FOOTER //
// ./js/self-serve/core/RudderstackUtils.js